<template>
  <div class="container-fluid mt-5">
    <div class="user-edit">
      <div slot="header" class="user-edit-header">
        <base-button @click="goBack" type="button" class="btn btn-sm">
          <i class="fal fa-arrow-left"></i>
          <span>{{ $t("COMMON.GO_BACK") }}</span>
        </base-button>
        <h3>{{ $t("USERS.EDIT_USER") }}</h3>
      </div>
      <user-form
        :loading="loading"
        :userData="user"
        :formErrors="formErrors"
        :showIsStaff="false"
        :showOrganization="false"
        :showReseller="false"
        @userSubmitted="handleSubmit"
        @formChanged="() => (alertLeave = true)"
      />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import UserForm from "@/views/Pages/AdminModule/UserManagement/partials/UserForm.vue";
import defaultUser from "@/views/Pages/AdminModule/UserManagement/defaultUser";
import requestErrorMixin from "@/mixins/request-error-mixin";

export default {
  layout: "DashboardLayout",

  components: { UserForm },

  mixins: [alertLeave, requestErrorMixin],

  data() {
    return {
      user: cloneDeep(defaultUser),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        await this.$store.dispatch("profile/me");
        this.user = { ...this.user, ...this.$store.getters["profile/me"] };
        this.loading = false;
      } catch (error) {
        this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "View Profile" });
    },

    async handleSubmit(user) {
      this.loading = true;

      const userData = cloneDeep(user);

      if (!userData.password) {
        delete userData.password;
        delete userData.password_confirmation;
      }

      delete userData.links;

      try {
        await this.$store.dispatch("users/update", userData);
        this.$notify({
          type: "success",
          timeout: 3000,
          message: this.$t("PROFILE.PROFILE_UPDATED"),
        });
        this.viewProfile();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },

    viewProfile() {
      this.alertLeave = false;
      this.$router.push({
        name: "View Profile",
      });
    },
  },
};
</script>
